import {ELEMENTALS_CONSTRUCTION_BAG} from "../../../configs/factions/elementals";

export const addMoreElementalsConstructionTokens = (existingTokens, additionalCount) => {
  // Исходный мешок (все возможные жетоны)
  const fullBag = [...ELEMENTALS_CONSTRUCTION_BAG];

  // Получаем список уже вытянутых жетонов (их названия)
  const drawnTokenNames = existingTokens.map(token => token.tokenName);

  // Определяем, какие жетоны остались в мешке
  const remainingBag = [...fullBag];

  // Удаляем из временной копии мешка все уже вытянутые жетоны
  for (const tokenName of drawnTokenNames) {
    const index = remainingBag.findIndex(t => t === tokenName);
    if (index !== -1) {
      remainingBag.splice(index, 1);
    }
  }

  // Теперь remainingBag содержит только жетоны, которые ещё не вытягивали
  const tokensToDraw = Math.min(additionalCount, remainingBag.length);

  if (tokensToDraw === 0) {
    // Если нечего вытягивать, возвращаем исходный массив
    return [...existingTokens];
  }

  // Вытягиваем новые жетоны
  const newDrawnTokens = [];
  for (let i = 0; i < tokensToDraw; i++) {
    const randomIndex = Math.floor(Math.random() * remainingBag.length);
    const token = remainingBag.splice(randomIndex, 1)[0];
    newDrawnTokens.push({
      tokenName: token,
      isUsed: false
    });
  }

  // Объединяем существующие и новые жетоны
  const allTokens = [...existingTokens, ...newDrawnTokens];

  // Сортируем: сначала по tokenName, а для одинаковых названий - сначала isUsed: true, потом false
  return allTokens.sort((a, b) => {
    // Сначала сравниваем по названию
    if (a.tokenName !== b.tokenName) {
      return a.tokenName.localeCompare(b.tokenName);
    }
    // Если названия одинаковые, то использованные (true) идут первыми
    return b.isUsed - a.isUsed; // true (1) > false (0), поэтому b - a даст сначала true
  });
}